import React from 'react';
import { motion } from 'framer-motion';
import { PROJECTS } from '../data/content';

export default function Projects() {
  return (
    <section id="projects" className="py-24 md:py-32 bg-page">
      <div className="container-x">
        <div className="max-w-3xl">
          <div className="section-label">{PROJECTS.eyebrow}</div>
          <h2 className="font-display text-[42px] md:text-[56px] leading-[1.02] mt-5">
            {PROJECTS.title}
            <span className="grad-text-red">{PROJECTS.titleAccent}</span>
          </h2>
          <p className="mt-6 text-[17px] text-[color:var(--muted)] leading-relaxed">{PROJECTS.intro}</p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {PROJECTS.cards.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="card-lift bg-white border border-line rounded-2xl p-7"
            >
              <div className="font-display text-navy text-2xl">{c.n}</div>
              <div className="mt-3 font-display text-[22px] text-[color:var(--ink)]">{c.title}</div>
              <p className="mt-3 text-[14.5px] text-[color:var(--muted)] leading-relaxed">{c.body}</p>
            </motion.div>
          ))}
        </div>

        {/* Intellectra AI partner strip */}
        <div className="mt-14 bg-[#1F2B73] rounded-3xl p-8 md:p-10 text-white grid md:grid-cols-12 gap-6 items-center">
          <div className="md:col-span-3 flex items-center gap-4">
            <div className="text-[10px] tracking-[0.22em] uppercase font-semibold text-white/60">Technology Partner</div>
          </div>
          <div className="md:col-span-3">
            <div className="bg-white rounded-xl px-5 py-3 inline-flex items-center gap-2">
              <img
                src="https://customer-assets-rejwkqb3.emergentagent.net/job_analytics-journey-8/artifacts/ia10zbrl_Intellectra%20AI.png"
                alt="Intellectra AI"
                className="h-8"
              />
            </div>
          </div>
          <div className="md:col-span-6 text-[15px] text-white/80 leading-relaxed">
            Every project you build is a live, real-time problem statement powered by our technology partner Intellectra AI —
            real data, real stakes, real experience.
          </div>
        </div>
      </div>
    </section>
  );
}
